import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WalletsPage.KycPage.wizard.CompanySectorStep.StepForm', {
    sectorLabel: 'Choose company sector (if several, select one)',
    sectorPlaceholder: 'Choose company sector',
    websiteLabel: 'Website/online presence',
    websitePlaceholder: 'Enter website/online presence...',
    dontHaveWebsiteLabel: 'I have no website/online presence',
    aboutLabel: 'About company',
    aboutPlaceholder: 'Tell us a bit more about what your company does, and how you market your services',
    uploadProof: 'Upload proof of business activity',
    requirements: 'JPG, PNG, PDF. Max 10 Mb',
});

export const companySectorMessages = defineMessages(
    'app.WalletsPage.KycPage.wizard.CompanySectorStep.StepForm.companySector',
    {
        accountancy: 'Accountancy',
        adultEntertainment: 'Adult Entertainment',
        adultProducts: 'Adult Products',
        advertisingOrPublicRelationsOrMarketing: 'Advertising, Public Relations or Marketing',
        aerospace: 'Aerospace',
        agricultural: 'Agricultural',
        architecture: 'Architecture',
        assetOrWealthManagementOrWealthTech: 'Asset or Wealth Management or Wealth Tech',
        automobileOrCarParts: 'Automobile or Car Parts',
        banking: 'Banking',
        barsOrRestaurants: 'Bars or Restaurants',
        bioSciencesOrBeautyProducts: 'Bio Sciences or Beauty Products',
        booksOrMagazinesAndNewspapers: 'Books, Magazines and Newspapers',
        broker: 'Broker',
        brokerDealer: 'Broker Dealer',
        buildingMaterialsAndEquipment: 'Building Materials and Equipment',
        callCentres: 'Call Centres',
        casinosOrGambling: 'Casinos or Gambling',
        chemicalAndRelatedManufacturing: 'Chemical and Related Manufacturing',
        clothingOrTextiles: 'Clothing or Textiles',
        computerOrCyberSecurity: 'Computer or Cyber Security',
        computerSoftware: 'Computer Software',
        construction: 'Construction',
        courierOrExpressOrParcel: 'Courier or Express or Parcel',
        cryptoassets: 'Cryptoassets',
        dataStorageOrProcessing: 'Data Storage or Processing',
        electronicEquipmentOrMobilePhones: 'Electronic Equipment or Mobile Phones',
        engineering: 'Engineering',
        estateOrLettingAgency: 'Estate or Letting Agency',
        etailorOrEcommerce: 'Etailor or Ecommerce',
        fitnessEquipment: 'Fitness Equipment',
        foodAndBeverage: 'Food and Beverage',
        forestryAndForestProducts: 'Forestry and Forest Products',
        freightOrLogistics: 'Freight or Logistics',
        fund: 'Fund',
        furnitureAndFlooring: 'Furniture and Flooring',
        gaming: 'Gaming',
        hedgeFundOrFamilyOffice: 'Hedge Fund or Family Office',
        highValueGoods: 'High Value Goods',
        historicalOrCulturalArtefacts: 'Historical or Cultural Artefacts',
        hospitalityOrEventsOrConferences: 'Hospitality or Events or Conferences',
        hospitalsAndCareFacilities: 'Hospitals and Care Facilities',
        hotels: 'Hotels',
        insuranceOrInsureTech: 'Insurance or Insure Tech',
        interiorDesign: 'Interior Design',
        itManagedServices: 'IT Managed Services',
        legal: 'Legal',
        loanCompany: 'Loan Company',
        loggingTimberAndPaperMills: 'Logging, Timber and Paper Mills',
        machineryAndToolsOrIndustrialEquipment: 'Machinery and Tools or Industrial Equipment',
        miningOrExtractiveIndustries: 'Mining or Extractive Industries',
        moneyServicesBusiness: 'Money Services Business',
        multiLevelMarketing: 'Multi-level Marketing',
        musicProduction: 'Music Production',
        nutritionalOrDietarySupplements: 'Nutritional or Dietary Supplements',
        oilAndGas: 'Oil and Gas',
        onlineMarketingOrBranding: 'Online Marketing or Branding',
        otherConsultancy: 'Other Consultancy',
        packaging: 'Packaging',
        pawnBrokers: 'Pawn Brokers',
        payrollCompanyOrPayTech: 'Payroll Company or Pay Tech',
        pharmaceuticalsOrMedicalDevices: 'Pharmaceuticals or Medical Devices',
        politicalGroupOrLobbying: 'Political Group or Lobbying',
        preciousMetals: 'Precious Metals',
        privateEquityOrInvestmentFirmOrVentureCapital: 'Private Equity or Investment Firm or Venture Capital',
        propertyDevelopment: 'Property Development',
        radioOrTvBroadcaster: 'Radio or TV Broadcaster',
        realEstateInvestment: 'Real Estate Investment',
        recruitment: 'Recruitment',
        registeredCharity: 'Registered Charity',
        regulatedOnlineMarketplaceOrPlatform: 'Regulated Online Marketplace or Platform',
        schoolsAndUniversities: 'Schools and Universities',
        security: 'Security',
        speculativeTrading: 'Speculative Trading',
        sportingOrProfessionalClub: 'Sporting or Professional Club',
        taxAdvisers: 'Tax Advisers',
        taxiOrPrivateTransport: 'Taxi or Private Transport',
        telecoms: 'Telecoms',
        tobaccoOrAlcohol: 'Tobacco or Alcohol',
        transportation: 'Transportation',
        travelAgentOrTravelWebsite: 'Travel Agent or Travel Website',
        trustAndCompanyFormationProviders: 'Trust and Company Formation Providers',
        trustCompany: 'Trust Company',
        unregisteredCharity: 'Unregistered Charity',
        utilities: 'Utilities',
        wasteManagementOrRecycling: 'Waste Management or Recycling',
        weaponsAndMilitaryEquipment: 'Weapons and Military Equipment',
        websiteOrAppDevelopment: 'Website or App Development',
    }
);
